var map = {
	"./IMG_0775.jpg": 4327,
	"./IMG_0976.jpg": 7226,
	"./IMG_0982.jpg": 8363,
	"./IMG_0989.jpg": 2340,
	"./IMG_0994.jpg": 4566,
	"./IMG_1054.jpg": 4788,
	"./IMG_1064.jpg": 845,
	"./IMG_1101.jpg": 8947,
	"./IMG_1122.jpg": 8414,
	"./IMG_1384.jpg": 1640,
	"./IMG_1439.jpg": 9127,
	"./WhatsApp Image 2025-11-18 at 3.38.00 PM (3).jpeg": 4952,
	"./WhatsApp Image 2025-11-18 at 3.38.03 PM (1).jpeg": 1309,
	"./WhatsApp Image 2025-11-18 at 3.38.03 PM (2).jpeg": 3202,
	"./a807f453-a2b2-47a8-8dc8-1a3460379767.jpg": 3024
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6415;